module.exports = __webpack_public_path__ + "img/metsahallitus.1b3dc832.jpg";